import React, { useState } from 'react';

import { IChangeEvent } from '@rjsf/core';
import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';

import { Alert, Button } from '@mui/material';

import VendorsService from '~/services/VendorsService';

import ErrorDisplay from '../ErrorDisplay';

const formSchema: RJSFSchema = {
  description: 'Please choose payment date period for export',
  type: 'object',
  properties: {
    startAt: {
      title: 'Select Start Date',
      type: 'string',
      format: 'date',
    },
    endAt: {
      title: 'Select End Date',
      type: 'string',
      format: 'date',
    },
  },
};

const uiSchema = {
  startAt: {
    'ui:widget': 'date',
  },
  endAt: {
    'ui:widget': 'date',
  },
  dateField: {
    'ui:widget': 'radio',
  },
};

export default function ExportTTCPaymentsReportForm() {
  const [error, setError] = useState(null);
  const [comment, setComment] = useState(null);

  const resetMessageState = () => {
    setError(null);
    setComment(null);
  };

  const handleSubmit = async (event: IChangeEvent) => {
    const { startAt, endAt } = event.formData;
    try {
      setComment('Downloading TTC Payments Report...');

      await VendorsService.downloadTTCPaymentsReport({
        startAt,
        endAt,
      });

      resetMessageState();
    } catch (err) {
      setError(`Error: ${err.message}`);
    }
  };

  return (
    <Form schema={formSchema} uiSchema={uiSchema} onSubmit={handleSubmit} validator={validator} showErrorList={false}>
      <Button type="submit" variant="contained">
        Download TTC Payments Report
      </Button>

      {error && <ErrorDisplay message={error} />}

      {comment && (
        <Alert severity="info">
          <p>{comment}</p>
        </Alert>
      )}
    </Form>
  );
}
